import jsQR from 'jsqr';

class QRCodeReader {
    public onQrCodeFound: ((codeData: string) => void) | null = null;

    private videoStarted = false;

    private videoElementToShowQrScanner: HTMLVideoElement;
    private dialogToHandleQrScanner: HTMLElement;
    private canvasElementToScanImage: HTMLCanvasElement;
    private media: MediaStreamConstraints = {
        audio: false,
        video: { facingMode: 'environment' },
    };
    private el: HTMLElement;

    constructor(el: HTMLElement) {
        this.el = el;
    }

    private startQrCodeScanner = (): void => {
        if (!this.videoStarted) {
            navigator.mediaDevices
                .getUserMedia(this.media)
                .then((stream: MediaStream) => {
                    this.videoElementToShowQrScanner.srcObject = stream;
                    this.dialogToHandleQrScanner.setAttribute('style', 'display: flex;');
                    this.videoStarted = true;
                    this.scanImage();
                })
                .catch(error => {
                    console.error(error);
                    this.videoStarted = false;
                });
        }
    };

    private stopQrCodeScanner = (): void => {
        if (this.videoElementToShowQrScanner.srcObject instanceof MediaStream) {
            this.videoElementToShowQrScanner.srcObject.getTracks().forEach(track => {
                track.stop();
            });
        }
        this.videoElementToShowQrScanner.srcObject = null;
        this.videoStarted = false;
        this.dialogToHandleQrScanner.setAttribute('style', 'display: none;');
    };

    private scanImage = (): void => {
        if (this.videoStarted) {
            const widthOfVideoElement = this.videoElementToShowQrScanner.clientWidth;
            const heightOfVideoElement = this.videoElementToShowQrScanner.clientHeight;
            this.canvasElementToScanImage.width = widthOfVideoElement;
            this.canvasElementToScanImage.height = heightOfVideoElement;
            this.canvasElementToScanImage.setAttribute('style', 'display: none;');

            const ctx = this.canvasElementToScanImage.getContext('2d', {
                willReadFrequently: true,
            }) as CanvasRenderingContext2D;

            ctx.drawImage(this.videoElementToShowQrScanner, 0, 0, widthOfVideoElement, heightOfVideoElement);
            const imageDataOfCanvasContext = ctx.getImageData(
                0,
                0,
                widthOfVideoElement,
                heightOfVideoElement
            );
            const code = jsQR(
                imageDataOfCanvasContext.data,
                imageDataOfCanvasContext.width,
                imageDataOfCanvasContext.height,
                {
                    inversionAttempts: 'dontInvert',
                }
            );

            if (code) {
                this.stopQrCodeScanner();

                this.onQrCodeFound(code.data);
            } else {
                setTimeout(() => {
                    this.scanImage();
                }, 100);
            }
        }
    };

    public handleScanner = (): void => {
        if (!this.canvasElementToScanImage && !this.videoElementToShowQrScanner) {
            this.videoElementToShowQrScanner = this.el.shadowRoot.getElementById(
                'qr-video'
            ) as HTMLVideoElement;
            this.canvasElementToScanImage = this.el.shadowRoot.getElementById(
                'qr-canvas'
            ) as HTMLCanvasElement;
            this.dialogToHandleQrScanner = this.el.shadowRoot.getElementById('qr-dialog') as HTMLDivElement;
        }

        if (!this.videoStarted) {
            this.startQrCodeScanner();
        } else {
            this.stopQrCodeScanner();
        }
    };
}

export default QRCodeReader;
